// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stack-card-box {
    background: transparent;
    border: 4px solid #ffffff;
    padding: 10px 15px;
    flex: 1 1;
    min-width: 250px;
    box-shadow: 0px 4px 4px 0px #0000001a;
    border-radius: 10px;
}

.stack-card-cont {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin: 10px 0px 30px 0px;
}

.sc-heading {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 7px;
    text-align: center;
}

.sc-value {
    font-size: 24px;
    font-weight: bold;
    color: #234B9A;
    text-align: center;
}
.input-container{
    display: flex;
    flex-direction: column;
    margin-bottom: 14px;
}
.input-container > small{
    font-weight: 500;
}
.input-container > input{
    border: 1px solid grey;
    border-radius: 10px;
    padding: 4px 10px;
    outline: none;
    font-size: 15px;
}
.input-container > select{
    border: 1px solid grey;
    border-radius: 10px;
    padding: 4px 10px;
    outline: none;
    font-size: 15px;
}
.blue-button{
    font-size: 16px;
    font-weight: 500;
    display: flex;
    gap: 1.2rem;
    padding: 4px 10px;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 20px;
    border: 2px solid transparent;
    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;
    color: #fff;
}
.blue-button:hover {
  color: #000;
  background: #fff;
  border: 2px solid #234B9A;
  font-weight: 600;
  cursor: pointer;
}
.blue-button:disabled{
    opacity: 0.7;
    cursor: not-allowed;
}

.cursor-pointer {
  cursor: pointer !important;
}

.transition-hover {
  transition: all 0.2s ease-in-out;
}

.transition-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}

.custom-stake-modal-dialog {
    max-width: 1120px !important;
    width: 95% !important;
}

@media screen and (max-width: 1200px) {
    .custom-stake-modal-dialog {
        max-width: 95% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ValidatorDelegator/index.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;IAC7B,uIAAuI;IACvI,WAAW;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".stack-card-box {\n    background: transparent;\n    border: 4px solid #ffffff;\n    padding: 10px 15px;\n    flex: 1;\n    min-width: 250px;\n    box-shadow: 0px 4px 4px 0px #0000001a;\n    border-radius: 10px;\n}\n\n.stack-card-cont {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.5rem;\n    margin: 10px 0px 30px 0px;\n}\n\n.sc-heading {\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 7px;\n    text-align: center;\n}\n\n.sc-value {\n    font-size: 24px;\n    font-weight: bold;\n    color: #234B9A;\n    text-align: center;\n}\n.input-container{\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 14px;\n}\n.input-container > small{\n    font-weight: 500;\n}\n.input-container > input{\n    border: 1px solid grey;\n    border-radius: 10px;\n    padding: 4px 10px;\n    outline: none;\n    font-size: 15px;\n}\n.input-container > select{\n    border: 1px solid grey;\n    border-radius: 10px;\n    padding: 4px 10px;\n    outline: none;\n    font-size: 15px;\n}\n.blue-button{\n    font-size: 16px;\n    font-weight: 500;\n    display: flex;\n    gap: 1.2rem;\n    padding: 4px 10px;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0px 4px 4px 0px #00000040;\n    border-radius: 20px;\n    border: 2px solid transparent;\n    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;\n    color: #fff;\n}\n.blue-button:hover {\n  color: #000;\n  background: #fff;\n  border: 2px solid #234B9A;\n  font-weight: 600;\n  cursor: pointer;\n}\n.blue-button:disabled{\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.transition-hover {\n  transition: all 0.2s ease-in-out;\n}\n\n.transition-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;\n}\n\n.custom-stake-modal-dialog {\n    max-width: 1120px !important;\n    width: 95% !important;\n}\n\n@media screen and (max-width: 1200px) {\n    .custom-stake-modal-dialog {\n        max-width: 95% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
